import React, { useState } from 'react';

import Config from '@skin_config';
import { useTranslation } from '@common/hooks/translation';
import CashoutBase from '@app/dev/terminal/components/cashout/base';
import PlayerCard from '@app/dev/terminal/components/playerCard';

import TransferToUserSearch from './search';
import TransferToUserConfirm from './confirm';
import TransferToUserSuccess from './success';
import { set } from 'lodash';

const TransferToUser = () => {
  const t = useTranslation();
  const [player, setPlayer] = useState(null);
  const [playerConfirmed, setPlayerConfirmed] = useState(false);
  const [amount, setAmount] = useState(null);
  const [isMaxAmount, setIsMaxAmount] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const isConfirmAmount = player && (isMaxAmount || +amount);

  const onAmountSubmit = (value, isMax) => {
    setAmount(value);
    setIsMaxAmount(isMax);
  };

  if (isSuccess) {
    return <TransferToUserSuccess player={player} amount={amount} isMaxAmount={isMaxAmount} />;
  }

  if (!player || !playerConfirmed) {
    return (
      <TransferToUserSearch
        player={player}
        onNext={(data) => { setPlayer(data); setPlayerConfirmed(true); }}
        onPlayerDelete={() => { setPlayerConfirmed(false); setPlayer(null); }}
      />
    );
  }

  if (isConfirmAmount) {
    return (
      <TransferToUserConfirm
        player={player}
        amount={amount}
        isMaxAmount={isMaxAmount}
        onSuccess={() => setIsSuccess(true)}
      />
    );
  }

  return (
    <CashoutBase
      icon="icon-cashout"
      title="Transfer"
      confirmButtonText="Next"
      placeholder="Transfer amount"
      hasPartialCashout={Config.balanceTransfer.enablePartialTransferToUser}
      description={(
        <>
          <p className="text-center">
            {t(Config.balanceTransfer.enablePartialTransferToUser ? 'Please input your transfer amount' : 'Do you wish to transfer')}
          </p>

          <PlayerCard data={player} variant="highlighted" />
        </>
      )}
      hasBack
      onBack={() => setPlayerConfirmed(false)}
      onSubmit={onAmountSubmit}
    />
  );
};

export default TransferToUser;
